<template>
    <div class="bg-ui-bg border border-ui-border flex flex-col rounded-xl overflow-clip w-full">
        <div class="relative w-full h-56 bg-lolo-600 dark:bg-lolo-800">
            <AirImg
                v-if="activity.imageName"
                class="size-full block"
                :alt="activity.name?.fr"
                :src="activity.imageName"
                :width="344"
                :height="224"
                :dpr="[1, 1.75]"
            />
            <div class="absolute w-full flex gap-1 top-0 left-0 p-3">
                <template v-for="tag in activity.tags" :key="tag.tag.id">
                    <Tag v-if="tag.visible" :text="$dbt(tag.tag.name)" />
                </template>
            </div>
        </div>
        <div class="py-6 px-4 flex flex-1 gap-5 justify-between flex-col">
            <div>
                <h3 class="text-xl font-bold mb-3">{{ $dbt(activity.name) }}</h3>
                <p class="text-sm font-semibold text-ui-text-toned pl-0.5 whitespace-pre-line">{{ $dbt(activity.description) }}</p>
            </div>
            <div>
                <div class="flex justify-end font-bold">{{ $t('from') }} {{ $n(activity.minPrice || 0, 'currency') }}</div>
                <!-- :to="activity.link" -->
                <!-- :label="$t('activity.discover')" -->
                <UButtonLocale
                    to="/"
                    size="xl"
                    :label="$t('contact')"
                    base-class="w-full rounded-full justify-center mb-1 mt-6 cursor-pointer"
                    class=""
                    @click="scrollToContact"
                >
                    <template #trailing>
                        <UIcon size="20" name="ph:arrow-right-bold" />
                    </template>
                </UButtonLocale>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Tag } from '.';
import type { Activity } from '~/types/activity';

defineProps<{
    activity: Activity;
}>();
const scrollToContact = () => {
    console.log('scrollToContact');
    const contact = document.getElementById('formulaire');
    if (contact) {
        contact.scrollIntoView({ behavior: 'smooth' });
    }
};
</script>

<style></style>
